import React, { FC, useCallback } from 'react';
import { useHistory } from 'react-router';

import { MasterOutletUpdate } from '@app/api/models/acb';
import { QueryTable } from '@app/components/common/table';
import { useApi, useFetchData } from '@app/hooks';
import { ROLES } from '@app/navigation/types';
import { usePermissions } from '@app/hooks/use-permissions';
import { getRoleName } from '@app/utils/jwt';
import { RequestPayload } from '@app/api/types';

import { useColumns } from './columns';

const UpdatesOutlets: FC = () => {
  const api = useApi();
  const canEdit = usePermissions({ roles: [ROLES.ADMIN, ROLES.CHIEF, ROLES.TRADE_MARKETING] });
  const columns = useColumns({ canEdit }); 
  const history = useHistory();
  let processType = 'others';
  if (getRoleName() === ROLES.TRADE_MARKETING) {
    processType = 'channels';
  } else if (getRoleName() === ROLES.ADMIN) {
    processType = undefined;
  } 

  const getUpdates = useCallback(
    (payload: RequestPayload) =>
      api.acb.getUpdates({
        ...payload,
        filter: { ...payload.filter, process_type: processType },
      }),
    [api, processType]
  );
  const [fetchData] = useFetchData<MasterOutletUpdate>({ method: getUpdates });
  return (
    <>
      <QueryTable<MasterOutletUpdate>
        title="Изменение ТТ"
        columns={columns}
        onCreateClick={() => history.push('/acl/updates-outlets/create')}
        fetchData={fetchData}
      />
    </>
  );
};

export default UpdatesOutlets;
